import { render, staticRenderFns } from "./CardsSlider.vue?vue&type=template&id=9a99f31e"
import script from "./CardsSlider.vue?vue&type=script&lang=js"
export * from "./CardsSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports